import React, {PureComponent} from 'react';
import './style.scss';
import Preloader from "../Preloader";
import BaseButton from "../form/Button";

export default class Index extends PureComponent {

    state = {
        hasError: false
    };

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary">
                    <div className="error-boundary__container">
                        <div className="error-boundary__preloader">
                            <Preloader height="130px"/>
                        </div>
                        <div className="error-boundary__title">
                            Кажется, что-то пошло не так...
                        </div>
                        <div className="error-boundary__reset-container">
                            <BaseButton
                                sizePadding="10px 0"
                                sizeBorderRadius={20}
                                isFullWidth
                                isGreenButton
                                onClick={() => window.location.reload()}
                            >
                                <span className="error-boundary__reset-text">
                                    Перегрузить
                                </span>
                            </BaseButton>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
